import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@mui/material/styles';
import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FaEquals } from 'react-icons/fa6';

import { GROUPED_COMPENSATION_SCHEMES_BY_BACKEND_KEY } from 'common/constants/rates';

import { ENERGY_CONCEPTS } from '../../constants';

import EnergyField from './EnergyField';
import FormAccordion from './FormAccordion';

const iconContainerProps = {
    size: 'grow',
    sx: { display: { xs: 'none', md: 'block' }, maxWidth: 'fit-content' },
};

const PeriodFields = ({
    baseName,
    compensationScheme,
    control,
    disabled,
    errors,
    onChangeEnergyConcept,
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const hasNetMetFields =
        GROUPED_COMPENSATION_SCHEMES_BY_BACKEND_KEY.NET_METERING.includes(
            compensationScheme,
        );

    return (
        <>
            <Grid container alignItems="center">
                <EnergyField
                    concept={ENERGY_CONCEPTS.SELF_CONSUMPTION}
                    control={control}
                    disabled={disabled}
                    name={baseName}
                    error={errors?.[ENERGY_CONCEPTS.SELF_CONSUMPTION]}
                    onBlur={onChangeEnergyConcept}
                />

                <Grid {...iconContainerProps}>
                    <AddIcon color="primary" />
                </Grid>

                <Grid size={{ md: 12, xs: 18 }}>
                    <Grid container alignItems="center">
                        <EnergyField
                            concept={ENERGY_CONCEPTS.GRID_CONSUMPTION}
                            control={control}
                            disabled={disabled}
                            name={baseName}
                            error={errors?.[ENERGY_CONCEPTS.GRID_CONSUMPTION]}
                            onBlur={onChangeEnergyConcept}
                        />

                        <Grid {...iconContainerProps}>
                            <FaEquals color={theme?.palette?.primary?.main} />
                        </Grid>

                        <EnergyField
                            concept={ENERGY_CONCEPTS.CONSUMPTION}
                            control={control}
                            disabled={disabled}
                            name={baseName}
                            error={errors?.[ENERGY_CONCEPTS.CONSUMPTION]}
                            onBlur={onChangeEnergyConcept}
                        />
                    </Grid>

                    <Grid container alignItems="center">
                        <EnergyField
                            concept={ENERGY_CONCEPTS.EXPORTED_ENERGY}
                            control={control}
                            disabled={disabled}
                            name={baseName}
                            error={errors?.[ENERGY_CONCEPTS.EXPORTED_ENERGY]}
                            onBlur={onChangeEnergyConcept}
                        />

                        <Grid {...iconContainerProps}>
                            <FaEquals color={theme?.palette?.primary?.main} />
                        </Grid>

                        <EnergyField
                            concept={ENERGY_CONCEPTS.GENERATION}
                            control={control}
                            disabled={disabled}
                            name={baseName}
                            error={errors?.[ENERGY_CONCEPTS.GENERATION]}
                            onBlur={onChangeEnergyConcept}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {hasNetMetFields && (
                <FormAccordion defaultExpanded title={t('Net metering')}>
                    <Grid container>
                        <EnergyField
                            concept={ENERGY_CONCEPTS.NET_CONSUMPTION}
                            control={control}
                            disabled={disabled}
                            name={baseName}
                            error={errors?.[ENERGY_CONCEPTS.NET_CONSUMPTION]}
                            onBlur={onChangeEnergyConcept}
                        />

                        <EnergyField
                            concept={ENERGY_CONCEPTS.BAG_ENERGY}
                            control={control}
                            disabled={disabled}
                            name={baseName}
                            error={errors?.[ENERGY_CONCEPTS.BAG_ENERGY]}
                            onBlur={onChangeEnergyConcept}
                        />
                    </Grid>
                </FormAccordion>
            )}
        </>
    );
};

PeriodFields.propTypes = {
    baseName: PropTypes.string,
    compensationScheme: PropTypes.string,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    onChangeEnergyConcept: PropTypes.func,
};
export default PeriodFields;
